export default __webpack_public_path__ + "static/media/DIN-Bold.24817c49.ttf";